import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { initSentry } from "./lib/sentry";

// ✅ FASE 2: Inicializar Sentry para error tracking
initSentry();

// ✅ FASE 2: Configurar React Query para cache otimizado
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos - dados considerados "frescos"
      gcTime: 10 * 60 * 1000, // 10 minutos - garbage collection
      refetchOnWindowFocus: false, // Não refetch ao voltar para a janela
      retry: 1, // Apenas 1 retry em caso de erro
      networkMode: 'online' // Só fazer queries quando online
    }
  }
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
